module.exports = __webpack_public_path__ + "static/media/ICON_TWITTER.204f2f20.svg";